import { useState } from 'react';
import Section from './ui/Section.jsx';
import Eyebrow from './ui/Eyebrow.jsx';
import Reveal from './ui/Reveal.jsx';
import ServiceCard from './ServiceCard.jsx';
import { services } from '../data/services.js';

export default function Services() {
  const [active, setActive] = useState(0);

  return (
    <Section id="behandeling" tone="sand" label="03 Behandeling">
      <Reveal
        style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 48, maxWidth: 720 }}
      >
        <Eyebrow>Behandeling</Eyebrow>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            fontSize: 'clamp(36px, 4vw, 56px)',
            lineHeight: 1.1,
            letterSpacing: '-0.01em',
            color: 'var(--ink)',
            margin: '14px 0 0',
          }}
        >
          Waarvoor kan je <span style={{ fontStyle: 'italic' }}>bij mij terecht?</span>
        </h2>
      </Reveal>

      <div
        className="section-grid-3"
        style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}
      >
        {services.map((s, i) => (
          <Reveal key={s.title} delay={120 * i}>
            <ServiceCard {...s} active={active === i} onClick={() => setActive(i)} />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
